import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let reviewsSwiperWr = document.querySelectorAll('.reviews-swiper-wr');

reviewsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let setSlidesSpaceBetween = (swiperInstance) => {
      let spaceBetween = swiperInstance.params.spaceBetween || 0;

      swiperInstance.slides.forEach((slide) => {
        slide.style.setProperty('--reviews-slide-space-between', `${spaceBetween}px`);
      });
    };

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 24,
      slidesPerView: 1,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        641: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        1023: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 122,
        }
      },
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        init(swiperInstance) {
          setSlidesSpaceBetween(swiperInstance);
        },
        resize(swiperInstance) {
          requestAnimationFrame(() => setSlidesSpaceBetween(swiperInstance));
        },
        breakpoint(swiperInstance) {
          requestAnimationFrame(() => setSlidesSpaceBetween(swiperInstance));
        },
      },
    });
    setSlidesSpaceBetween(swiper);
    swiperObserver(swiper);
  }
});